<template>
  <main>
    <v-toolbar flat>
      <v-toolbar-title>{{ $t("heading.airport_car_routes") }}</v-toolbar-title>
      <v-spacer />
      <v-btn
        :to="{ name: 'airport_routes_create', query: { ...$route.query } }"
        large
        class="primary"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t("button.create") }}
      </v-btn>
    </v-toolbar>
    <v-expansion-panels class="mb-8 mt-4" focusable v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>{{
          $t("filter_by")
        }}</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container fluid>
            <v-row>
              <v-col cols="12" lg="6" class="mx-0">
                <AutoCompleteFilter
                  :label="$t('fields.car_classification')"
                  :items="car_classifications"
                  item-text="name"
                  item-value="id"
                  filterName="car_classification"
                />
              </v-col>
              <v-col cols="12" lg="6" class="mx-0">
                <AutoCompleteFilter
                  :label="$t('fields.tourism_cities')"
                  :items="tourismCities"
                  item-text="name"
                  item-value="id"
                  filterName="tourism_city"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- table -->
    <wrapping-table
      ref="table_ref"
      :headersName="headers"
      pathName="airport-car-routes"
      resName="airport_car_routes"
      class="table-row"
    >
      <template slot-scope="{ item, index }">
        <td class="text-sm-center">{{ item.name }}</td>
        <td class="text-center">
          {{ item.car_classification.name }}
        </td>
        <td class="text-center">
          {{ item.city.name }}
        </td>
        <td class="text-center">
          {{ item.area ? item.area : "---" }}
        </td>

        <td class="text-center">
          {{ item.price }}
        </td>
        <td class="toggle-spacing text-center">
          {{ item.reserve_before_start_in_hours }}
        </td>

        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="car-classifications"
            :model-id="item.id"
            field="visible"
            v-model="item.visible"
            :validate="true"
          />
        </td>
        <td class="toggle-spacing text-center">
          <toggle-service
            :is-edit="true"
            model-name="airport-car-routes"
            :model-id="item.id"
            field="auto_accept_order"
            v-model="item.auto_accept_order"
            :validate="true"
          />
        </td>

        <td class="text-sm-center">
          <v-btn
            icon
            color="info"
            :to="`/car/airport-car-routes/edit/${item.id}`"
          >
            <v-icon :title="$t('icon.edit')" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon>
            <v-icon
              color="error"
              @click="handleDelete(item, index)"
              :title="$t('icon.delete')"
              small
              >mdi-delete</v-icon
            >
          </v-btn>
        </td>
      </template>
    </wrapping-table>
    <!-- table -->
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "AirportCarRoutes",
  data() {
    return {
      panel: 0,
      tourismCities: [],
      car_classifications: [],
      overlay: false,
      imagePath: "",
      dummyIcon: "https://via.placeholder.com/50x50?text=icon",

      headers: [
        "name",
        "car_classification",
        "tourism_city",
        "area",
        "price",
        "reserve_before_start_in_hours",
        "visible",
        "auto_accept_order",
        "actions"
      ]
    };
  },
  mounted() {
    this.getTourismCities();
    this.getCarClassifications();
  },
  methods: {
    handleDelete({ id }, index) {
      this.$refs.table_ref.handleDelete(id, index);
    },
    async getTourismCities() {
      const res = await IndexData({
        reqName: "tourism-cities",
        query: { pagination: "all" }
      });
      const { tourism_cities } = res.data;
      this.tourismCities = tourism_cities;
    },

    async getCarClassifications() {
      const res = await IndexData({
        reqName: "car-classifications",
        query: { pagination: "all" }
      });
      const { car_classifications } = res.data;
      this.car_classifications = car_classifications;
    }
  }
};
</script>
